/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const Container = styled.label`
  background: white;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: 100%;
  display: flex;

  color: ${({ theme }) => theme.colors.gray};
  svg {
    color: ${(props) => props.iconColor};
    path {
      &.b {
        color: ${(props) => props.iconColor};
        fill: ${(props) => props.iconColor};
      }
    }
  }

  padding: 8px 12px 8px 12px;
  height: 140px;
  transition: border-color 0.5s, color 0.5s;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #dc3545;
      svg {
        color: #dc3545;
        path {
          &.b {
            color: #dc3545;
            fill: #dc3545;
          }
        }
      }
    `}

  ${(props) =>
    props.isFocused &&
    css`
      border-color: ${props.borderHighlightColor};
      svg {
        color: ${props.borderHighlightColor};

        path {
          &.b {
            color: ${props.borderHighlightColor};
            fill: ${props.borderHighlightColor};
          }
        }
      }
    `}

    ${(props) =>
    props.disabled &&
    css`
      border: 1px solid #c1c1c1;
      background-color: #eeeeee;
    `}

    svg:first-child {
    margin-right: 7px;
  }

  svg:last-child {
    margin-left: 7px;
  }

  div {
    display: flex;
    flex: 1;
    position: relative;
    flex-direction: column;

    span {
      color: ${({ theme }) => theme.colors.lightGray};
    }

    textarea {
      flex: 1;
      background: transparent;
      border: 0;
      color: ${({ theme }) => theme.colors.gray};
      outline: none !important;
      padding: 0;
      margin-top: -5px;
      resize: none;

      &::placeholder {
        color: #666360;
      }
    }
  }
`;

export const ErrorText = styled.span`
  color: #dc3545;
`;

export const LabelText = styled.span`
  color: ${({ theme }) => theme.colors.mediumGray};

  position: absolute;
  padding-top: ${({ labelActivated }) => (labelActivated ? '2px' : '10px')};

  transition: all 1s;
  transform: translateY(-3px);

  font-weight: 400;
  font-size: ${({ labelActivated }) =>
    labelActivated ? '0.825rem' : '0.975rem'};

  ${(props) =>
    props.labelActivated &&
    css`
      position: initial;
      transform: translateY(0);
    `}
`;
